import { render, staticRenderFns } from "./InProgressPage.vue?vue&type=template&id=230f9351&scoped=true"
import script from "./InProgressPage.vue?vue&type=script&lang=js"
export * from "./InProgressPage.vue?vue&type=script&lang=js"
import style0 from "./InProgressPage.vue?vue&type=style&index=0&id=230f9351&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230f9351",
  null
  
)

export default component.exports